var exports = {
  "kL": "x28a7bf27--351890--container",
  "mx": "x28a7bf27--351890--image-block",
  "om": "x28a7bf27--351890--block",
  "D7": "x28a7bf27--351890--gradient",
  "vW": "x28a7bf27--351890--inner",
  "wx": "x28a7bf27--351890--header",
  "Qq": "x28a7bf27--351890--text",
  "lZ": "x28a7bf27--351890--phone",
  "wQ": "x28a7bf27--351890--email-link",
};

module.exports = exports;
